import { defineComponent as _defineComponent } from 'vue'
import router from "@/router";
  import { computed, onMounted, ref } from "vue";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'DashboardUpcoming',
  props: {
    upcomingArray: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  setup(__props, { expose: __expose }) {
  __expose();

  const props = __props;

  function actionText(text: string) {
    return text.endsWith("lot") ? text.slice(0, -3) : `${text} for`;
  }

  function actionRouting(stageId: string, lotId: string) {
    router.push({
      name: "LotActions",
      params: {
        stageId: stageId,
        lotId: lotId,
      },
    });
  }

const __returned__ = { props, actionText, actionRouting, get router() { return router }, computed, onMounted, ref }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})